import Sponsor1 from '../img/sponsors/sponsor1.png'
import Sponsor2 from '../img/sponsors/sponsor2.png'
import Sponsor3 from '../img/sponsors/sponsor3.svg'
import Sponsor4 from '../img/sponsors/sponsor4.png'
import Sponsor5 from '../img/sponsors/sponsor5.svg'
import Sponsor6 from '../img/sponsors/sponsor6.svg'
import Sponsor7 from '../img/sponsors/sponsor7.svg'
import Sponsor8 from '../img/sponsors/sponsor8.svg'
import Sponsor9 from '../img/sponsors/sponsor9.svg'
import Sponsor10 from '../img/sponsors/sponsor10.svg'
import Sponsor11 from '../img/sponsors/sponsor11.svg'
import Sponsor12 from '../img/sponsors/sponsor12.svg'


const sponsorsData = [
    { logo: Sponsor1 },
    { logo: Sponsor2 },
    { logo: Sponsor3 },
    { logo: Sponsor4 },
    { logo: Sponsor5 },
    { logo: Sponsor6 },
    { logo: Sponsor7 },
    { logo: Sponsor8 },
    { logo: Sponsor9 },
    { logo: Sponsor10  },
    { logo: Sponsor11  },
    { logo: Sponsor12  },
  ];
  
  export default sponsorsData;
  